import { Modal, ModalBody, ModalHeader } from "reactstrap";
import React from "react";

/**
 * A modal component for displaying content in a modal dialog.
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to display inside the modal
 * @param {boolean} [props.removeModal=false] - Flag to conditionally render children without modal
 * @param {boolean} [props.isOpen=false] - Flag to control whether the modal is open or closed
 * @param {Function} props.onToggle - Function to handle modal toggle
 * @param {string} [props.title=''] - Title to display in the modal header
 * @param {string} [props.bodyClass=''] - Additional class names for the modal body
 * @param {string} [props.headerClass=''] - Additional class names for the modal header
 * @param {boolean} [props.centered=true] - Flag to center the modal
 * @param {string} [props.minWidth='auto'] - Minimum width of the modal
 * @param {string} [props.minHeight='auto'] - Minimum height of the modal
 * @returns {JSX.Element} The AppModal component
 */
const AppModal = ({
  children,
  removeModal = false,
  isOpen = false,
  onToggle,
  title = "",
  bodyClass = "",
  headerClass = "",
  centered = true,
  minWidth = "auto",
  minHeight = "auto",
}) => {
  if (removeModal) return children;

  return (
    <Modal isOpen={isOpen} toggle={onToggle} centered={centered} style={{ minWidth: minWidth }}>
      <ModalHeader className={`border-bottom-0 ${headerClass}`} tag='h5' toggle={onToggle}>
        {title}
      </ModalHeader>
      <ModalBody className={bodyClass} style={{ minHeight: minHeight }}>
        {children}
      </ModalBody>
    </Modal>
  );
};

export default AppModal;
